import Upload from './src/index';

module.exports = Upload;


// WEBPACK FOOTER //
// ./src/components/upload/index.js